import { useClassifiedId } from "@/contexts/classified";
import { useContactSections } from "@/contexts/contact";
import { useBrand } from "@aviv-unified-frontend/runtime/brand";
export const useCallTrackingRequest = () => {
    var _a, _b, _c;
    const { id } = useBrand();
    // @ts-ignore
    const { agencyId } = (_a = useContactSections()) !== null && _a !== void 0 ? _a : {};
    // @ts-ignore
    const { phoneNumbers = [] } = (_c = (_b = useContactSections()) === null || _b === void 0 ? void 0 : _b.contactCard) !== null && _c !== void 0 ? _c : {};
    const classifiedId = useClassifiedId();
    // callTracking API expects phone numbers separated by '/' to be split into separate entries
    const formattedPhoneNumbers = phoneNumbers.flatMap((number) => number.includes(" / ") ? number.split(" / ").map((n) => n.trim()) : [number]);
    const calltrackingRequestParams = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {
            agencyId,
            brand: id.toUpperCase(),
            realPhoneNumbers: formattedPhoneNumbers,
            // @ts-ignore
            classifiedId,
        },
    };
    return {
        method: calltrackingRequestParams.method,
        headers: calltrackingRequestParams.headers,
        body: JSON.stringify(calltrackingRequestParams.body),
    };
};
